import { NgModule } from '@angular/core';
import { DashboardRoutingModule } from './dashboard-routing.module'
import { TableModule } from 'primeng/table';
import { HttpClientModule, HTTP_INTERCEPTORS, } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {PanelModule} from 'primeng/panel';
import { FormsModule } from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import { NgxPermissionsModule } from 'ngx-permissions';
import {TabMenuModule} from 'primeng/tabmenu';
import {InputMaskModule} from 'primeng/inputmask';
import { MultiSelectModule} from 'primeng/multiselect';
import {DropdownModule} from 'primeng/dropdown';
import {TabViewModule} from 'primeng/tabview';
import {RadioButtonModule} from 'primeng/radiobutton';
import { DashboardComponent } from './dashboard.component';
import { ActiveDealersDashboardComponent } from './active-dealers-dashboard.component';
import {ClientFilesPostageTrackingReportComponent} from './client-files-postage-tracking-report.component'
import {SelectButtonModule} from 'primeng/selectbutton';
import {GoogleChartsModule} from 'angular-google-charts';


@NgModule({
  imports: [
    DashboardRoutingModule,
    TableModule,
    TabViewModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    PanelModule,
    FormsModule,
    DialogModule,
    NgxPermissionsModule,
    TabMenuModule,
    InputMaskModule,
    MultiSelectModule,
    DropdownModule,
    RadioButtonModule,
    SelectButtonModule,
    GoogleChartsModule
  ],
  declarations: [    
    
    DashboardComponent,
    ActiveDealersDashboardComponent,
    ClientFilesPostageTrackingReportComponent
    
  ]
})
export class DashboardModule { }
